import {Key, ReactNode} from 'react';

import {ModifiersEnum} from '../../../../../srcCommon/inboxes/search/searchModifiersHelpers';
import {
  SearchModifierHintTypesEnum,
  SearchStaticHintTypesEnum,
  SearchStaticModifierHintTypesEnum,
} from '../../../../models/api/searchHintModel';
import {InboxesSearchLocationsEnum} from '../../../../models/url/models/inboxesUrlModel';
import {SearchLocalFilterIconType} from '../../../../store/panels/inboxes/parameters/inboxesParametersFiltersIconHelpers';

interface VisualSearchHintValueBase {
  key: Key;
  title: string;
  isSelected: boolean;

  icon: SearchLocalFilterIconType | undefined;
}

interface VisualModifierSearchHintValue extends VisualSearchHintValueBase {
  modifier: ModifiersEnum;
  emoji: string | undefined;
  value: string;
}

interface VisualLocationSearchHintValue extends VisualSearchHintValueBase {
  tooltip: ReactNode | undefined;
  value: InboxesSearchLocationsEnum;
}

export type VisualSearchHintValue = VisualModifierSearchHintValue | VisualLocationSearchHintValue;

interface VisualSearchHintBase<T extends VisualSearchHintValue> {
  key: Key;
  type:
    | SearchModifierHintTypesEnum
    | SearchStaticModifierHintTypesEnum
    | SearchStaticHintTypesEnum.SEARCH_FILTERS;
  values: ReadonlyArray<T>;
}

export interface VisualModifierSearchHint extends VisualSearchHintBase<VisualModifierSearchHintValue> {
  type: SearchModifierHintTypesEnum | SearchStaticModifierHintTypesEnum;
  isTransient: boolean;

  // FIXME(ldemarne): Come up with something better.
  // values = selected values.
  suggestedValues?: ReadonlyArray<VisualModifierSearchHintValue>;
}

export interface VisualLocationSearchHint extends VisualSearchHintBase<VisualLocationSearchHintValue> {
  type: SearchStaticHintTypesEnum.SEARCH_FILTERS;
}

export type VisualSearchHint = VisualModifierSearchHint | VisualLocationSearchHint;

export function isLocationHint(visualHint: VisualSearchHint): visualHint is VisualLocationSearchHint {
  return visualHint.type === SearchStaticHintTypesEnum.SEARCH_FILTERS;
}
